import { dispatch } from '@store';
import { updatePropertyValue, updatePropertyValueError } from '@store/actions/widgets.actions';
import { useQuery } from '@tanstack/react-query';
import { PropertyValues } from '@types';
import { instance } from '@utils/fetch';
import { config } from 'config';
import { useEffect } from 'react';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const usePropertyValueQuery = (loanNumber: string) => {
    const queryKey = ['propertyValue', loanNumber];
    const query = useQuery({
        queryKey: queryKey,
        queryFn: async () =>
            await instance.request({
                url: `${config.env('awsUrl')}/api/v1/selfserv/loans/${loanNumber}/property-value`,
                method: 'get'
            }),
        select: ({ data }: any) => data,
        onSuccess: async (propertyValue: PropertyValues) => {
            const data = propertyValue;
            if (propertyValue) {
                const loans = Array.isArray(data?.loans) ? data.loans : null;
                const loanData = loans?.find((loan: any) => loan.loanNumber === loanNumber);

                const isDataError = Boolean(data?.errorMessage);
                const isLoanDataInvalid = !loanData || Boolean(loanData?.errorMessage);
                const isEstimatesMissing =
                    !loanData?.estimates || !Array.isArray(loanData?.estimates) || loanData?.estimates.includes(undefined);

                const hasPropertyValueError = isDataError || isLoanDataInvalid || isEstimatesMissing;

                if (hasPropertyValueError) dispatch(updatePropertyValueError(true));
                else dispatch(updatePropertyValue(propertyValue));
            }
        },
        onError: async () => {
            dispatch(updatePropertyValueError(true));
        }
    });

    return query;
};
